import { Grid } from "@mui/material";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <Grid
      container
      className="auth-container"
      alignItems="center"
      justifyContent="center"
      sx={{
        padding: { xs: "16px", sm: "1.5rem", md: "2rem" },
        minHeight: { xs: "100dvh", sm: "100vh" },
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className="auth-background-image-container" />

      <Grid
        item
        xs={12}
        sm={10}
        md={6}
        lg={4}
        xl={3}
        sx={{
          zIndex: 9,
          width: { xs: "100%", sm: "100%" },
          maxWidth: { xs: 420, sm: 450, md: 500 },
          margin: { xs: "0 auto", sm: 0 },
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
